import React, {useState, useEffect} from 'react';
import LCVHelpButton from './LCVHelpButton';
import QuestionRenderer from './QuestionRenderer';

const KnowledgeCheckPhase = ({
  question,
  questionIndex,
  totalQuestions,
  kcAnswers,
  onSubmit,
  onNext,
  nextDisabled = false,
}) => {
  const [submitted, setSubmitted] = useState(false);
  const [isCorrect, setIsCorrect] = useState(null);

  useEffect(() => {
    setSubmitted(false);
    setIsCorrect(null);
  }, [questionIndex]);

  const handleSubmit = (selectedAnswer) => {
    const correct = selectedAnswer === question.correctAnswer;
    setIsCorrect(correct);
    setSubmitted(true);
    onSubmit(selectedAnswer);
  };

  return (
    <div className="lcv-check-panel">
      <div className="lcv-check-header">
        <span className="lcv-check-badge">KNOWLEDGE CHECK</span>
        <div className="lcv-check-header-meta">
          <LCVHelpButton phase="knowledge_check" />
          <span className="lcv-check-count">
            Question {questionIndex + 1} of {totalQuestions}
          </span>
        </div>
      </div>

      <QuestionRenderer
        question={question}
        onSubmit={handleSubmit}
        showFeedback={submitted}
        isCorrect={isCorrect}
      />

      {submitted && (
        <button
          className="lcv-btn-primary lcv-btn-full"
          onClick={onNext}
          disabled={nextDisabled}>
          {questionIndex + 1 < totalQuestions ? 'Next Question →' : 'See Results →'}
        </button>
      )}
    </div>
  );
};

export default KnowledgeCheckPhase;
